
import axios from 'axios'
import { getSession, getCookie, } from "./cookie"
import { Message, Loading } from 'element-ui'

const service = axios.create({
  // baseURL: "/admin",
  baseURL: process.env.NODE_ENV === 'production' ? 'https://erp.zuizhenshi.cn' :
    process.env.NODE_ENV === 'development' ? '/admin' :
      '/',
  // '/admin',
  timeout: 600000, // request timeout
})
let loading = null;
service.interceptors.request.use(
  config => {

    if (config.method !== 'get') {

      loading = Loading.service({
        lock: true,
        text: '请求数据中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.7)'
      });
    }
    if (config.headers['Content-Type'] && config.method === 'post') {
      config.headers['Content-Type'] = 'application/json';
    } else {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    let sessionId = getSession()
    if (sessionId) {
      config.headers['X-Token'] = sessionId;
    }
    return config
  },
  error => {

    if (loading !== null) {
      loading.close();
    }
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response

    if (loading !== null) {
      loading.close();
    }
    return res.data
  },
  error => {

    if (error.response) {
      Message({
        message: error.response.data.error.code || error.response.data.error.message,
        type: 'error',
        duration: 5 * 1000
      })
      if (loading !== null) {
        loading.close();
      }
      return Promise.reject(error)
    }

  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js